import React from 'react';
import dogImg from '../../images/CheckoutConfirmation/dog.png';
import dogPawIcon from '../../images/CheckoutConfirmation/dog-paw.svg';
import dogKissImg from '../../images/CheckoutConfirmation/dog-kiss.png';
import ollieBoxIcon from '../../images/CheckoutConfirmation/ollie-box.svg';
import instagramIcon from '../../images/SocialMediaIcons/instagram.svg';
import tiktokIcon from '../../images/SocialMediaIcons/tiktok.svg';
import facebookIcon from '../../images/SocialMediaIcons/facebook.svg';
import twitterIcon from '../../images/SocialMediaIcons/twitter.svg';
import spotifyIcon from '../../images/SocialMediaIcons/spotify.svg';
import pinterestIcon from '../../images/SocialMediaIcons/pinterest.svg';
import { SplitPanelBody } from '../../components';
import {
  features,
  buttonText,
  viewAccountURL,
  description,
  headline,
} from '../AccountFeatures/constants';
import { Referral } from './Referral';

export const splitPanels = [
  {
    image: {
      alt: `Dog`,
      src: dogImg.src,
    },
    backgroundColor: `hero.spinach`,
    alignImage: 'right',
    centered: false,
    content: (
      <SplitPanelBody
        heading={`Refer and Earn $40`}
        body={
          <>
            <p>
              Invite a friend to try Ollie with a special discount and get $40
              off your next box.
            </p>
            <Referral />
          </>
        }
        icon={{
          alt: 'Dog Paw - Refer and Earn',
          src: dogPawIcon.src,
          width: dogPawIcon.width,
          height: dogPawIcon.height,
        }}
      />
    ),
  },
  {
    content: (
      <SplitPanelBody
        icon={{
          alt: 'Dog',
          src: ollieBoxIcon.src,
          width: ollieBoxIcon.width,
          height: ollieBoxIcon.height,
        }}
        heading={`Welcome to the pack`}
        body={
          <p>
            Join our community and tag #MyOllie to show us us what you and your
            pup are up to.
          </p>
        }
        socialMediaIcons={[
          {
            src: instagramIcon.src,
            alt: 'Instagram',
            url: 'https://www.instagram.com/ollie/',
          },
          {
            src: facebookIcon.src,
            alt: 'Facebook',
            url: 'https://www.facebook.com/MyOllie',
          },
          {
            src: twitterIcon.src,
            alt: 'Twitter',
            url: 'https://twitter.com/olliepets',
          },
          {
            src: tiktokIcon.src,
            alt: 'Tiktok',
            url: 'https://www.tiktok.com/@ollie',
          },
          {
            src: pinterestIcon.src,
            alt: 'Pinterest',
            url: 'https://www.pinterest.com/myolliedotcom/',
          },
          {
            src: spotifyIcon.src,
            alt: 'Spotify',
            url: 'https://open.spotify.com/user/ski5m70d8oulhj06d5ss6w1xm',
          },
        ]}
      />
    ),
    image: {
      alt: `Dog`,
      src: dogKissImg.src,
    },
    backgroundColor: `secondary.egg`,
    alignImage: 'left',
    centered: false,
  },
];

export const ORDER_CONFIRMATION_OLLIE_APP_BANNER_PROPS = {
  title: 'Introducing the all new Ollie app!',
  bodyText: 'Get box updates, manage your subscription, and more.',
  appStoreButtonsFlow: 'column',
};

export const confirmationHeroProps = {
  customerName: 'Bartolo',
  date: 'Wednesday, June 30',
};

export const confirmationOrderSummaryProps = {
  orders: [
    {
      petName: 'Martin',
      breeds: ['Maltese'],
      subtotal_ex_tax: '100.0',
      total_ex_tax: '50.0',
      total_discount: '50.0',
      price: 100.0,
      discountedPrice: 50.0,
      isDiscounted: true,
      pricePerWeek: 25.0,
      pricePerMeal: 5.0,
      frequencyInWeeks: 4,
      deliveryNext: 'Thursday, Aug 5',
      recipe: {
        fresh: ['Beef', 'Chicken', 'Turkey'],
        dry: ['Beef', 'Chicken'],
      },
    },
    {
      petName: 'Chuck',
      breeds: ['Chihuahua'],
      subtotal_ex_tax: '100.0',
      total_ex_tax: '50.0',
      total_discount: '50.0',
      price: 100.0,
      discountedPrice: 50.0,
      isDiscounted: true,
      pricePerWeek: 25.0,
      pricePerMeal: 5.0,
      frequencyInWeeks: 4,
      deliveryNext: 'Thursday, Aug 5',
      recipe: {
        fresh: ['Chicken'],
      },
    },
    {
      petName: 'Kitty',
      breeds: ['Poodle'],
      subtotal_ex_tax: '100.0',
      total_ex_tax: '50.0',
      total_discount: '50.0',
      price: 100.0,
      discountedPrice: 50.0,
      isDiscounted: true,
      pricePerWeek: 30.0,
      pricePerMeal: 0.0,
      frequencyInWeeks: 4,
      deliveryNext: 'Friday, Aug ',
      recipe: {
        dry: ['Beef', 'Chicken'],
      },
    },
  ],
  deliveryAddress: {
    street: '10 Martine Rd.',
    city: 'Milton',
    state: 'MA',
    zip: '02186-4420',
  },
  cardBrand: 'visa',
  wallet: null,
  cardNumberLastFour: 7777,
  deliveryDate: 'Wednesday, June 30',
  orderTotalCost: '107.0',
  orderTotalTax: '7.00',
  orderSubtotal: '100.00',
  orderSummaryTitle: 'order summary',
  period: 'week',
};

export const accountFeatureProps = {
  features,
  buttonText,
  viewAccountURL,
  description,
  headline,
};
